export default class MathHelpers {
    static RandomInteger(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}